import React from "react";
import styles from "../../MapPopupStyles.js";
import { withStyles } from "@material-ui/core/styles";
import { TableCell, TableRow, Tooltip } from "@material-ui/core";

const Content = ({ classes, theme, contentData }) => {
  return contentData.map((eachRow) => {
    const lastLabel = eachRow.labels.length - 1;
    const lastValue = eachRow.values.length - 1;
    return (
      <TableRow className={classes.tableRowRoot}>
        <TableCell
          className={`${classes.labelCell} ${
            classes?.[eachRow.labelClass]
          } tableCellName`}
        >
          {eachRow.labels.map((label, index) => (
            <React.Fragment key={`label-${index}`}>
              {label}
              {index !== lastLabel && <span className={classes.dividerStyle} />}
            </React.Fragment>
          ))}
        </TableCell>
        <TableCell
          className={`${classes.dataCell} ${classes.popupDataStyle} ${
            classes?.[eachRow.valueClass]
          } tableCellValue`}
        >
          {eachRow.values.map((value, index) => (
            <React.Fragment key={`value-${index}`}>
              {eachRow.showTooltip ? (
                <Tooltip
                  classes={{
                    popper: "popper",
                    tooltip: `tooltip-${theme}`,
                  }}
                  title={value}
                >
                  <div className={classes.SpecialInstruction}>{value}</div>
                </Tooltip>
              ) : (
                value
              )}
              {index !== lastValue && <span className={classes.dividerStyle} />}
            </React.Fragment>
          ))}
        </TableCell>
      </TableRow>
    );
  });
};

export default withStyles(styles)(Content);
